import { logException } from '@babylon/sentry'

export default (src: string, fallback: string) => () =>
  new Promise<string>((resolve) => {
    const img = new Image()
    img.addEventListener('load', () => resolve(src))
    img.addEventListener('error', () => {
      logException(`Failed to load image "${src}"`)

      return resolve(fallback)
    })
    img.src = src
  })
